import { Delete, Edit } from '@mui/icons-material';
import {
    AppBar,
    Box,
    Checkbox,
    Chip,
    Container,
    CssBaseline,
    FormControl,
    IconButton,
    ListItemText,
    MenuItem,
    Paper,
    Select,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Typography,
} from '@mui/material';
import React, { useRef, useState } from 'react';
import { useServiceContext } from '../components/Context/ServiceContext';
import ConfirmDialog from '../views/ConfirmDialog';
import EditDialogCategory from '../views/EditDialog/EditDialogServiceCategory';
import EditDialogServiceAdditional from '../views/EditDialog/EditDialogServiceAdditional';
import TabPanel from '../views/TabPanel'; // Import the TabPanel component
import { useSnackbar } from './SnackBar';
import { useProgressBar } from './ProgressBar';
const ServicePage = () => {
    const { showSnackbar } = useSnackbar();
    const { showProgress } = useProgressBar();
    const [tabIndex, setTabIndex] = useState(0); // State to manage active tab
    const categoryRef = useRef(null);
    const serviceRef = useRef(null);
    const iconRef = useRef(null);
    const fileRef=useRef(null);
    const [showInCustomerApp, setShowInCustomerApp] = useState(true);
    const [isActiveCategory, setIsActiveCategory] = useState(true);
    const catalogNameRef = useRef(null);
    const catalogPriceRef = useRef(null);
    const catalogDescriptionRef = useRef(null);
    const catalogDiscountRef = useRef(null);
    const catalogServiceChargeRef = useRef(null);
    const catalogIsPeriodicRef = useRef(null);
    const catalogIsQuickSelectRef = useRef(null);
    const catalogFileRef = useRef(null);
    const [catalogCategoryId, setCatalogCategoryId] = useState('');
    const [catalogFile, setCatalogFile] = useState(null);
    const [catalogDiscountEnabled, setCatalogDiscountEnabled] = useState(false);
    const [catalogDiscount, setCatalogDiscount] = useState('');
    const [catalogHomeServiceEnabled, setCatalogHomeServiceEnabled] = useState(false);
    const [catalogServiceCharge, setCatalogServiceCharge] = useState('');
    const [catalogAdditionalIds, setCatalogAdditionalIds] = useState([]);
    const [catalogAdditionalNames, setCatalogAdditionalNames] = useState([]);
    const { AddServiceCategory, AddServiceByAdmin, DeleteAdditionalService, AddAditionalService, FetchAdditionalService, serviceCategory, additionalService, UpdateServiceCategory, editServiceCategory, DeleteServiceCategory, UpdateAdditionalService, editAdditionalService, editOpen, editType, currentEditData, setEditOpen } = useServiceContext();
    const [open, setOpen] = useState(false);
    const [selectedCategoryId, setSelectedCategoryId] = useState(null); // Store the ID of the brand to delete
    const [selectedServiceId, setSelectedServiceId] = useState(null); // Store the ID of the brand to delete
    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
        // Reset filter when switching tabs
        if (newValue === 1) {
            //setSelectedBrandFilter('');
        }

    };
   
    const handleAddCategory = async () => {
        if (categoryRef.current.value.trim() === '' || selectedFile == null) {
            handleClick();
            showSnackbar('Name/Icon cannot be blank', 'error');
            return;
        }
        else {
            showProgress(true);
            await AddServiceCategory({
                id: 0,
                name: categoryRef.current.value.trim(),
                icon: "",
                showInCustomerApp,
                isActive: isActiveCategory
            }, selectedFile);
            setShowInCustomerApp(true);
            setIsActiveCategory(true);
            showProgress(false);
            showSnackbar('This is a test message', 'warning');
        }
    };

    const [selectedFile, setSelectedFile] = useState(null);
    const [fileFormattype,setFileFormatType]=useState(false);
    const [fileFormatsize,setFileFormatSize]=useState(false);
    const checkFileFormat=async (event) =>{
        if(fileRef.current.value!=""){
            const validFileTypes = ['image/jpeg', 'image/png']; 
            const maxSize = 5 * 1024 * 1024;
            const ftype=event.target.files[0];
            if(!validFileTypes.includes(ftype.type)){
                setFileFormatType(true)
            }else{
                setFileFormatType(false)
            }
            if(ftype.size>maxSize){
                setFileFormatSize(true)
            }else{
                setFileFormatSize(false)
            }
          
        }
 };
 const formRefs=useRef([]);
    const handleClick=()=>{
    const formElements=formRefs.current.elements;
        for(let element of formElements){
            if(element.tagName==='INPUT'&&element.type!=='button'){
            if(element.value===""){
            element.style.borderColor='red';
        }else{
            element.style.borderColor='';
        }

    }
}
};
const emptyCheck=(e)=>{
    if(e.target.value===""){
        e.target.style.borderColor='';
    }else{
        e.target.style.borderColor='';
    }
};
    // Function to handle file selection
    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]); // Get the first selected file
    };
    const handleAddService = async () => {
        if (serviceRef.current.value.trim() === '') {
            handleClick();
            showSnackbar('Name cannot be blank', 'error');
            return;
        }

        await AddAditionalService({ id: 0, name: serviceRef.current.value.trim() });
        showSnackbar('This is a test message', 'warning');
    };

    const handleCatalogAdditionalChange = (event) => {
        const { value } = event.target;
        const selected = typeof value === 'string' ? value.split(',') : value;
        setCatalogAdditionalNames(selected);
        setCatalogAdditionalIds(selected.map((id) => String(id)));
    };

    const resetCatalogForm = () => {
        if (catalogNameRef.current) catalogNameRef.current.value = '';
        if (catalogPriceRef.current) catalogPriceRef.current.value = '';
        if (catalogDescriptionRef.current) catalogDescriptionRef.current.value = '';
        if (catalogFileRef.current) catalogFileRef.current.value = '';
        setCatalogCategoryId('');
        setCatalogFile(null);
        setCatalogDiscountEnabled(false);
        setCatalogDiscount('');
        setCatalogHomeServiceEnabled(false);
        setCatalogServiceCharge('');
        setCatalogAdditionalIds([]);
        setCatalogAdditionalNames([]);
        if (catalogIsPeriodicRef.current) catalogIsPeriodicRef.current.checked = false;
        if (catalogIsQuickSelectRef.current) catalogIsQuickSelectRef.current.checked = false;
    };

    const handleAddCatalogService = async () => {
        const name = catalogNameRef.current?.value?.trim() || '';
        const price = catalogPriceRef.current?.value?.trim() || '';
        const description = catalogDescriptionRef.current?.value?.trim() || '';

        if (!name || !price || !catalogCategoryId) {
            showSnackbar('Service name, price, and category are required', 'error');
            return;
        }

        showProgress(true);
        try {
            const payload = {
                name,
                ServiceCategoryId: parseInt(catalogCategoryId, 10),
                price: parseFloat(price),
                description,
                imageUrl: '',
                additionalServiceId: catalogAdditionalIds,
                finalPrice: 0,
                discounted: catalogDiscountEnabled,
                homeServiceEnabled: catalogHomeServiceEnabled,
                serviceCharge: catalogHomeServiceEnabled
                    ? parseFloat(catalogServiceChargeRef.current?.value || catalogServiceCharge || 0)
                    : 0,
                discountPercentage: catalogDiscountEnabled
                    ? parseFloat(catalogDiscountRef.current?.value || catalogDiscount || 0)
                    : 0,
                isPeriodic: catalogIsPeriodicRef.current?.checked || false,
                isQuickSelect: catalogIsQuickSelectRef.current?.checked || false,
            };

            const result = await AddServiceByAdmin(payload, catalogFile);
            const created = result?.createdCount ?? 0;
            const skipped = result?.skippedPartners ?? 0;
            showSnackbar(
                `Service created for ${created} partner(s)` +
                    (skipped > 0 ? ` (${skipped} skipped — no branches)` : ''),
                'success'
            );
            resetCatalogForm();
        } catch (error) {
            console.error('Error adding catalog service:', error);
            showSnackbar('Error creating service for partners. Please try again.', 'error');
        } finally {
            showProgress(false);
        }
    };

    const handleDeleteClick = (id) => {
     
        setSelectedCategoryId(id); // Set the brand ID to delete
        setOpen(true); // Open the confirmation dialog
    };
    const handleDeleteAdditionalClick = (id) => {

        setSelectedServiceId(id); // Set the brand ID to delete
        setOpen(true); // Open the confirmation dialog
    };

    const handleClose = () => {
        setOpen(false); // Close the confirmation dialog
        setSelectedCategoryId(null); // Clear the selected brand ID
    };

    const handleConfirm = () => {
        if (selectedCategoryId) {
            DeleteServiceCategory(selectedCategoryId); // Delete the selected brand
        }

        if (selectedServiceId) {
            DeleteAdditionalService(selectedServiceId); // Delete the selected brand
        }
        setOpen(false); // Close the confirmation dialog

    };
    const handleConfirmAdditionalService = () => {
        if (selectedCategoryId) {
            DeleteAdditionalService(selectedCategoryId); // Delete the selected brand
        }
        setOpen(false); // Close the confirmation dialog
    };
    // Handle Save from Edit Dialog
    const handleSaveEditCategory = (name, serviceCategoryId, file, showInApp, isActive) => {

        if (editType === 'category') {
            UpdateServiceCategory(
                {
                    name,
                    showInCustomerApp: showInApp !== false,
                    isActive: isActive !== false
                },
                serviceCategoryId,
                file
            );
        }
    };
    const handleSaveEditAdditionalService = (updatedData) => {

        if (editType === 'additionalservice') {
            UpdateAdditionalService(updatedData)
        }


    };
    return (
        <main id="main" className="main">
            <div className="pagetitle">
                <h1>Service</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/admin">Home</a></li>
                        <li className="breadcrumb-item"><a href="#">Service</a></li>
                        
                    </ol>
                </nav>
            </div>
            <section className="section">
                <div className="row">


                    <div className="col-lg-10">

                        <div className="card">
                            <div className="card-body">

                                <h5 className="card-title"></h5>




                                <CssBaseline />
                                <Container maxWidth="md" sx={{ mt: 4 }}>
                                    {/*<Typography variant="h6" align="center" gutterBottom>*/}
                                    {/*  Car Admin Panel*/}
                                    {/*</Typography>*/}

                                    {/* Tabs */}
                                    <Box sx={{ width: '100%' }}>
                                        <AppBar position="static" color="transparent">
                                            <Tabs
                                                value={tabIndex}
                                                onChange={handleTabChange}
                                                indicatorColor="primary"
                                                textColor="primary"
                                                variant="fullWidth"
                                                aria-label="admin tabs"
                                            >
                                                <Tab label="Category" id="admin-tab-0" aria-controls="admin-tabpanel-0" />
                                                <Tab label="Additional Services" id="admin-tab-1" aria-controls="admin-tabpanel-1" />
                                                <Tab label="Services" id="admin-tab-2" aria-controls="admin-tabpanel-2" />

                                            </Tabs>
                                        </AppBar>

                                        {/* Tab Panels */}
                                        <TabPanel value={tabIndex} index={0}>
                                            {/* Category Management */}
                                            <form ref={formRefs}>
                                                <div className="row mb-3">
                                                    <label htmlFor="icon" className="col-sm-2 col-form-label">Category Name</label>
                                                    <div className="col-sm-10">
                                                        <input type="text" ref={categoryRef}  className="form-control" onBlur={(e)=>{emptyCheck(e);} }/>
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label htmlFor="inputNumber" className="col-sm-2 col-form-label">File Upload</label>
                                                    <div className="col-sm-10">
                                                        <input className="form-control" type="file" id="formFile" ref={fileRef}onChange={handleFileChange} onBlur={(e)=>{
                                                                                                                                                                        emptyCheck(e);checkFileFormat(e);}}/>
                                                    {fileFormattype==true &&(<div className="form-text text-danger">{fileFormattype==true ? "Invalid file type. Please upload an image file (jpeg, png).":""}</div>)}{fileFormatsize==true&&(<div className="form-text text-danger">{fileFormatsize==true ? "File size too large. Please upload a file smaller than 5MB.":""}</div>)}
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label htmlFor="isActiveCategory" className="col-sm-2 col-form-label">Active</label>
                                                    <div className="col-sm-10 d-flex align-items-center">
                                                        <div className="form-check form-switch">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id="isActiveCategory"
                                                                checked={isActiveCategory}
                                                                onChange={(e) => setIsActiveCategory(e.target.checked)}
                                                            />
                                                            <label className="form-check-label" htmlFor="isActiveCategory">
                                                                Available for branch / order screens
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label htmlFor="showInCustomerApp" className="col-sm-2 col-form-label">Show in Customer App</label>
                                                    <div className="col-sm-10 d-flex align-items-center">
                                                        <div className="form-check form-switch">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id="showInCustomerApp"
                                                                checked={showInCustomerApp}
                                                                onChange={(e) => setShowInCustomerApp(e.target.checked)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="text-left">
                                                    <label htmlFor="icon" className="col-sm-2 col-form-label"></label>
                                                    <button type="button" onClick={handleAddCategory} className="btn btn-primary">Save</button>

                                                </div>

                                            </form>
                                            <Box mb={4} />

                                            <TableContainer component={Paper}>
                                                <Table aria-label="brands table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell><strong>Category Name</strong></TableCell>
                                                            <TableCell><strong>Active</strong></TableCell>
                                                            <TableCell><strong>Show in Customer App</strong></TableCell>
                                                            <TableCell align="right"><strong>Actions</strong></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {serviceCategory.length === 0 && (
                                                            <TableRow>
                                                                <TableCell colSpan={4} align="center">
                                                                    <Typography variant="body1">No brands available.</Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                        )}
                                                        {serviceCategory.map((category) => (
                                                            <TableRow key={category.serviceCategoryId}>
                                                                <TableCell>{category.serviceCategoryName}</TableCell>
                                                                <TableCell>{category.isActive !== false ? 'Yes' : 'No'}</TableCell>
                                                                <TableCell>{category.showInCustomerApp !== false ? 'Yes' : 'No'}</TableCell>
                                                                <TableCell align="right">
                                                                    <IconButton
                                                                        color="primary"
                                                                        onClick={() => editServiceCategory(category)}>

                                                                        <Edit />
                                                                    </IconButton>
                                                                    <IconButton
                                                                        color="secondary"
                                                                        onClick={() => handleDeleteClick(category.serviceCategoryId)} // Trigger delete confirmation for this brand
                                                                    >
                                                                        <Delete />
                                                                    </IconButton>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>


                                                <ConfirmDialog
                                                    open={open}
                                                    onClose={handleClose}
                                                    onConfirm={handleConfirm}
                                                    title="Confirm Deletion"
                                                    content="Are you sure you want to delete this Service?"
                                                />
                                            </TableContainer>

                                        </TabPanel>
                                        <TabPanel value={tabIndex} index={1}>
                                            {/* Additional service Management */}
                                            <form ref={formRefs}>
                                                <div className="row mb-3">
                                                    <label htmlFor="icon" className="col-sm-2 col-form-label">Service Name</label>
                                                    <div className="col-sm-10">
                                                        <input type="text" ref={serviceRef} className="form-control" onBlur={(e)=>{emptyCheck(e);} }/>
                                                    </div>
                                                </div>



                                                <div className="text-left">
                                                    <label htmlFor="icon" className="col-sm-2 col-form-label"></label>
                                                    <button type="button" onClick={handleAddService} className="btn blue-button">Save</button>

                                                </div>

                                            </form>
                                            <Box mb={4} />

                                            <TableContainer component={Paper}>
                                                <Table aria-label="additional service table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell><strong>Additional Service</strong></TableCell>
                                                            <TableCell align="right"><strong>Actions</strong></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {additionalService.length === 0 && (
                                                            <TableRow>
                                                                <TableCell colSpan={2} align="center">
                                                                    <Typography variant="body1">No Additional Service available.</Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                        )}
                                                        {additionalService.map((brand) => (
                                                            <TableRow key={brand.id}>
                                                                <TableCell>{brand.name}</TableCell>
                                                                <TableCell align="right">
                                                                    <IconButton
                                                                        color="primary"
                                                                        onClick={() => editAdditionalService(brand)}>

                                                                        <Edit />
                                                                    </IconButton>
                                                                    <IconButton
                                                                        color="secondary"
                                                                        onClick={() => handleDeleteAdditionalClick(brand.id)} // Trigger delete confirmation for this brand
                                                                    >
                                                                        <Delete />
                                                                    </IconButton>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>


                                                <ConfirmDialog
                                                    open={open}
                                                    onClose={handleClose}
                                                    onConfirm={handleConfirm}
                                                    title="Confirm Deletion"
                                                    content="Are you sure you want to delete this Service?"
                                                />
                                            </TableContainer>

                                        </TabPanel>

                                        <TabPanel value={tabIndex} index={2}>
                                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                                This service will be created for every partner and linked to all of their branches.
                                            </Typography>
                                            <form>
                                                <div className="row mb-3">
                                                    <label className="col-sm-2 col-form-label">Name</label>
                                                    <div className="col-sm-10">
                                                        <input type="text" className="form-control" ref={catalogNameRef} />
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label className="col-sm-2 col-form-label">Service Category</label>
                                                    <div className="col-sm-10">
                                                        <FormControl fullWidth size="small">
                                                            <Select
                                                                displayEmpty
                                                                value={catalogCategoryId}
                                                                onChange={(e) => setCatalogCategoryId(e.target.value)}
                                                            >
                                                                <MenuItem value="">
                                                                    <em>Select category</em>
                                                                </MenuItem>
                                                                {serviceCategory.map((category) => (
                                                                    <MenuItem
                                                                        key={category.serviceCategoryId}
                                                                        value={String(category.serviceCategoryId)}
                                                                    >
                                                                        {category.serviceCategoryName}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label className="col-sm-2 col-form-label">Price</label>
                                                    <div className="col-sm-10">
                                                        <input type="number" className="form-control" ref={catalogPriceRef} min="0" step="0.01" />
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label className="col-sm-2 col-form-label">Description</label>
                                                    <div className="col-sm-10">
                                                        <input type="text" className="form-control" ref={catalogDescriptionRef} />
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label className="col-sm-2 col-form-label">Image</label>
                                                    <div className="col-sm-10">
                                                        <input
                                                            className="form-control"
                                                            type="file"
                                                            accept="image/jpeg,image/png"
                                                            ref={catalogFileRef}
                                                            onChange={(e) => setCatalogFile(e.target.files?.[0] || null)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label className="col-sm-2 col-form-label">Additional Services</label>
                                                    <div className="col-sm-10">
                                                        <FormControl fullWidth size="small">
                                                            <Select
                                                                multiple
                                                                displayEmpty
                                                                value={catalogAdditionalNames}
                                                                onChange={handleCatalogAdditionalChange}
                                                                renderValue={(selected) => (
                                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                                        {selected.length === 0 && <em>Optional</em>}
                                                                        {selected.map((value) => {
                                                                            const item = additionalService.find((a) => a.id === value);
                                                                            return <Chip key={value} label={item?.name || value} size="small" />;
                                                                        })}
                                                                    </Box>
                                                                )}
                                                            >
                                                                {additionalService.map((item) => (
                                                                    <MenuItem key={item.id} value={item.id}>
                                                                        <Checkbox checked={catalogAdditionalNames.includes(item.id)} />
                                                                        <ListItemText primary={item.name} />
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label className="col-sm-2 col-form-label">Periodic</label>
                                                    <div className="col-sm-10 d-flex align-items-center">
                                                        <div className="form-check form-switch">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id="catalogIsPeriodic"
                                                                ref={catalogIsPeriodicRef}
                                                            />
                                                            <label className="form-check-label" htmlFor="catalogIsPeriodic">
                                                                Mark as periodic service
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label className="col-sm-2 col-form-label">Quick Select</label>
                                                    <div className="col-sm-10 d-flex align-items-center">
                                                        <div className="form-check form-switch">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id="catalogIsQuickSelect"
                                                                ref={catalogIsQuickSelectRef}
                                                            />
                                                            <label className="form-check-label" htmlFor="catalogIsQuickSelect">
                                                                Show as quick select in partner app
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label className="col-sm-2 col-form-label">Discount</label>
                                                    <div className="col-sm-10">
                                                        <div className="form-check form-switch mb-2">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id="catalogDiscount"
                                                                checked={catalogDiscountEnabled}
                                                                onChange={(e) => setCatalogDiscountEnabled(e.target.checked)}
                                                            />
                                                            <label className="form-check-label" htmlFor="catalogDiscount">
                                                                Enable Discount
                                                            </label>
                                                        </div>
                                                        {catalogDiscountEnabled && (
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                ref={catalogDiscountRef}
                                                                value={catalogDiscount}
                                                                onChange={(e) => setCatalogDiscount(e.target.value)}
                                                                min="0"
                                                                max="100"
                                                                placeholder="Discount %"
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label className="col-sm-2 col-form-label">Home Service</label>
                                                    <div className="col-sm-10">
                                                        <div className="form-check form-switch mb-2">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id="catalogHomeService"
                                                                checked={catalogHomeServiceEnabled}
                                                                onChange={(e) => setCatalogHomeServiceEnabled(e.target.checked)}
                                                            />
                                                            <label className="form-check-label" htmlFor="catalogHomeService">
                                                                Enable Home Service
                                                            </label>
                                                        </div>
                                                        {catalogHomeServiceEnabled && (
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                ref={catalogServiceChargeRef}
                                                                value={catalogServiceCharge}
                                                                onChange={(e) => setCatalogServiceCharge(e.target.value)}
                                                                min="0"
                                                                placeholder="Service charge"
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="text-left">
                                                    <label className="col-sm-2 col-form-label"></label>
                                                    <button type="button" onClick={handleAddCatalogService} className="btn btn-primary">
                                                        Save for all partners
                                                    </button>
                                                </div>
                                            </form>
                                        </TabPanel>

                                    </Box>


                                    <EditDialogCategory
                                        open={editOpen}
                                        handleClose={() => setEditOpen(false)}
                                        type={editType}
                                        currentData={currentEditData}

                                        handleSave={handleSaveEditCategory}
                                    />
                                    <EditDialogServiceAdditional
                                        open={editOpen}
                                        handleClose={() => setEditOpen(false)}
                                        type={editType}
                                        currentData={currentEditData}

                                        handleSave={handleSaveEditAdditionalService}
                                    />


                                </Container>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default ServicePage;

